<div class="modal-header">
  <strong class="text-custom-theme bold fs-5 d-inline-block">
    ประกาศระบบตามสอบสินค้าเกษตรบนระบบคลาวด์ (QR Trace on Cloud)
  </strong>
  <button type="button" aria-label="Close" class="btn-close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <div class="row mb-1 ps-4 pe-4">
    <!-- Logo Section -->
    <div class="row mb-3 g-0 flex-nowrap justify-content-center">
      <img src="/assets/images/logo_acfs.png" alt="Logo" class="" style="width: 150px;">
    </div>

    <!-- Title Section -->
    <div class="row mb-2 g-0 flex-nowrap justify-content-center">
      <span class="text-center h5">
        รายละเอียดการดำเนินการเปิดการใช้งาน ระบบตามสอบสินค้าเกษตรบนระบบคลาวด์ (QR Trace on Cloud)
      </span>
    </div>
    <br>

    <!-- Timeline Table -->
    <div class="row justify-content-center">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="table-success">
            <tr class="text-center">
              <th scope="col">วันที่</th>
              <th scope="col" style="width: 35%;">กิจกรรม</th>
              <th scope="col" style="width: 35%;">หมายเหตุ</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>๒๔ มิถุนายน - ๓๐ กรกฎาคม ๒๕๖๘</td>
              <td>เปิดใช้งานเครื่องทดสอบ<br>(https://dev.acfs.go.th)</td>
              <td>ข้อมูลที่บันทึกในระบบทดสอบจะไม่ย้ายไประบบใหม่</td>
            </tr>
            <tr>
              <td>๓๐ - ๓๑ กรกฎาคม ๒๕๖๘<br>(เวลา ๐๐.๐๐ – ๒๓.๕๙ น.)</td>
              <td>ปิดระบบเดิมเพื่อถ่ายโอนข้อมูลผู้ใช้งาน</td>
              <td>วันที่ ๓๑ กรกฎาคม ๒๕๖๘ ทั้งวัน ไม่สามารถใช้งานระบบได้</td>
            </tr>
            <tr>
              <td>๑ สิงหาคม ๒๕๖๘</td>
              <td>เปิดใช้งานระบบใหม่<br>(https://qrtrace.acfs.go.th)</td>
              <td>ระบบเดิมยังใช้งานได้ถึงวันที่ ๑๗ สิงหาคม ๒๕๖๘</td>
            </tr>
            <tr>
              <td>๔ สิงหาคม ๒๕๖๘<br>(เวลา ๐๙.๐๐ – ๑๒.๐๐ น.)</td>
              <td>ประชุมชี้แจงการใช้งานระบบฯ ใหม่</td>
              <td></td>
            </tr>
            <tr>
              <td>๑๘ สิงหาคม ๒๕๖๘</td>
              <td>ปิดการใช้งานระบบฯ เดิม<br>(www.acfs-qrtrace.com)</td>
              <td>ไม่สามารถเข้าใช้งานระบบเดิมได้ ทั้งนี้ QR Code จะสามารถแสดงผลได้ระยะหนึ่งหลังจากปิดระบบเเล้ว เพื่อให้เคลียร์สินค้าที่มี QR Code เก่าที่ค้างอยู่ และให้เวลาผู้ประกอบการสร้าง <br>QR Code จากระบบใหม่ใช้แทนในสินค้าล็อตใหม่</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Important Note -->
    <div class="row mb-3">
      <span class="text-danger h5">
        <strong><ins>หมายเหตุ</ins></strong>
        <span class="text-danger">
          &nbsp;&nbsp;การเพิ่มข้อมูลหลักในระบบฯ เดิม จะไม่สามารถถ่ายโอนข้อมูลมายังระบบฯ ใหม่ได้หลังจากวันที่ ๑ สิงหาคม ๒๕๖๘
        </span>
      </span>
    </div>

    <!-- Contact Info -->
    <div class="row mb-4">
      <span>หากมีข้อสงสัยโปรดติดต่อ</span>
      <br>
      <span>เบอร์โทร: ๐๒-๕๖๑๒๒๗๗ ต่อ ๑๕๒๖ และ ๑๕๒๒</span>
      <br>
      <span>Email: qrtrace&#64;acfs.go.th</span>
      <br>
      <span>ขอบคุณที่ให้ความร่วมมือและขออภัยในความไม่สะดวก</span>
    </div>

    <!-- Preparation Details Section Title -->
    <div class="row mb-2 g-0 flex-nowrap justify-content-center">
      <span class="text-center h5">รายละเอียดการเตรียมความพร้อมสำหรับผู้ประกอบการ</span>
    </div>

    <!-- Preparation Table -->
    <div class="row mb-4">
      <div class="col">
        <table class="table table-bordered align-middle">
          <thead class="table-success text-center">
          <tr>
            <th style="text-align: center;">ลำดับ</th>
            <th style="width: 45%;">รายละเอียดเอกสาร</th>
            <th style="width: 45%;">หมายเหตุ</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="text-center">๑</td>
            <td>ดาวน์โหลดและลงทะเบียนแอปพลิเคชัน ThaID เพื่อใช้ในการยืนยันตัวตน</td>
            <td>ใช้บัตรประจำตัวประชาชน</td>
          </tr>
          <tr>
            <td class="text-center">๒</td>
            <td>email และเบอร์ติดต่อ เพื่อใช้ในการลงทะเบียน</td>
            <td>
              สำหรับผู้สมัครใช้งาน (ใหม่)<br>
              <span class="text-danger">**กรณีผู้ใช้งานเก่า สามารถใช้ username/password เดิม</span>
            </td>
          </tr>
          <tr>
            <td class="text-center">๓</td>
            <td>ข้อมูลผู้ประกอบการ เช่น ข้อมูลผู้ติดต่อ, ชื่อกิจการ/บริษัท, เลขทะเบียนนิติบุคคล, ที่อยู่ และพิกัด เป็นต้น</td>
            <td>สามารถเลือกพิกัดจากแผนที่ในระบบได้</td>
          </tr>
          <tr>
            <td class="text-center align-top">๔</td>
            <td>
              ข้อมูลหลัก (Master Data) ที่ใช้ในการบันทึกข้อมูล ตัวอย่างเช่น
              <ol class="thai-number" style="margin-top: 10px;">
                <li>ทะเบียนสินค้า
                  <ul style="margin-top: 5px;">
                    <li>ชื่อสินค้า เช่น ไข่ไก่แพ็ค ๔ ฟอง</li>
                    <li>ชนิดส่วนประกอบของสินค้า เช่น ไข่ไก่สด</li>
                    <li>ปริมาณต่อ ๑ หน่วย เช่น ๔</li>
                    <li>หน่วยในการรับ เช่น ฟอง, แผง เป็นต้น</li>
                  </ul>
                </li>
                <li>ทะเบียนวัตถุดิบ
                  <ul style="margin-top: 5px;">
                    <li>ชนิดวัตถุดิบ เช่น ไข่ไก่สด</li>
                    <li>ชื่อวัตถุดิบ เช่น ไข่ไก่ เป็นต้น</li>
                  </ul>
                </li>
                <li>ทะเบียนเกษตรกรที่ส่งวัตถุดิบ</li>
                <li>ทะเบียนผู้ติดต่อ
                  <ul style="margin-top: 5px;">
                    <li>ข้อมูลผู้จำหน่ายและลูกค้า</li>
                  </ul>
                </li>
                <li>ทะเบียนแปลง/ฟาร์ม
                  <ul style="margin-top: 5px;">
                    <li>ข้อมูลแปลง/ฟาร์มของเกษตรกรที่ส่งวัตถุดิบ</li>
                  </ul>
                </li>
              </ol>
              เป็นต้น
            </td>
            <td class="align-top">
              การระบุข้อมูลทะเบียนสินค้าอย่างครบถ้วน เช่น ชนิดส่วนประกอบ, ปริมาณ และหน่วยรับ มีความจำเป็นต่อการคำนวณและควบคุมสต็อกในระบบให้แม่นยำ
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Meeting Schedule Section -->
    <div class="row">
      <div class="col text-center h5">
        กำหนดการประชุมชี้แจงแนวทางการใช้งานระบบตามสอบสินค้าเกษตรบนระบบคลาวด์ (QR Trace on Cloud)
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center h5">วันจันทร์ที่ ๔ สิงหาคม ๒๕๖๘ เวลา ๐๙.๐๐ - ๑๒.๐๐ น.</div>
      <div class="col-12 text-center h5">ผ่านระบบ Zoom</div>
      <div class="col-12 text-center h5">Meeting ID: 991 3875 0745</div>
      <div class="col-12 text-center h5">Passcode: 972190</div>
    </div>

    <br>
    <hr>
    <br>

    <!-- Meeting Schedule Table -->
    <div class="row mb-5">
      <div class="col-12">
        <div class="d-flex justify-content-center ms-5 ps-5">
          <table class="table table-borderless" style="width: auto; max-width: 700px;">
            <tbody>
            <tr>
              <td class="text-center" style="min-width: 120px;">๐๘.๓๐ – ๐๙.๐๐</td>
              <td class="text-start" style="padding-left: 20px;">เปิดห้องชี้แจง</td>
            </tr>
            <tr>
              <td class="text-center">๐๙.๐๐ – ๐๙.๑๕</td>
              <td class="text-start" style="padding-left: 20px;">ชี้แจงวัตถุประสงค์ของการจัดการประชุมครั้งนี้</td>
            </tr>
            <tr>
              <td class="text-center">๐๙.๑๕ – ๑๐.๔๕</td>
              <td class="text-start" style="padding-left: 20px;">ทำความเข้าใจเกี่ยวกับระบบ QR Trace on Cloud และอธิบายการใช้งานโปรแกรม</td>
            </tr>
            <tr>
              <td class="text-center">๑๐.๔๕ – ๑๑.๐๐</td>
              <td class="text-start" style="padding-left: 20px;">พัก</td>
            </tr>
            <tr>
              <td class="text-center">๑๑.๐๐ – ๑๒.๐๐</td>
              <td class="text-start" style="padding-left: 20px;">ตอบข้อซักถาม ข้อสงสัยการใช้งานโปรแกรม</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row mb-5">
      <span>ลิงก์ขั้นตอนการสมัครสมาชิกเพื่อเข้าใช้งาน</span>
      <div class="col">
        <a href="https://youtu.be/2QQoUPNzLBQ?si=jiE7luuxp-zs2488" target="_blank">https://youtu.be/2QQoUPNzLBQ?si=jiE7luuxp-zs2488</a>
      </div>
    </div>
    <!-- QR Code Sections -->
    <div class="row mb-5">
      <div class="col-12">
        <span class="text-danger">QR Code สำหรับดาวน์โหลดคู่มือการใช้งาน</span>
      </div>
      <div class="col-12 mt-2">
        <img src="/assets/images/anounce-page-image/doc_qr.png" alt="QR Code คู่มือ" style="width: 150px;">
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">QR Code เข้ากลุ่ม LINE OpenChat เพื่อติดตามข้อมูลข่าวสาร</div>
      <div class="col-12 mt-1">
        <span class="text-danger">*** โปรดเปลี่ยนชื่อ Line เป็นรหัสผู้ประกอบการของท่าน</span>
      </div>
      <div class="col-12 mt-2">
        <img src="/assets/images/anounce-page-image/line_qr.png" alt="QR Code LINE" style="width: 150px;">
      </div>
    </div>

    <!-- Contact Info (Repeat) -->
    <div class="row mb-4">
      <span>หากมีข้อสงสัยโปรดติดต่อ</span>
      <br>
      <span>เบอร์โทร: ๐๒-๕๖๑๒๒๗๗ ต่อ ๑๕๒๖ และ ๑๕๒๒</span>
      <br>
      <span>Email: qrtrace&#64;acfs.go.th</span>
      <br>
      <span>ขอบคุณที่ให้ความร่วมมือและขออภัยในความไม่สะดวก</span>
    </div>

    <!-- Close Button -->
    <div class="row">
      <div class="col text-center">
        <button type="button" class="btn btn-custom btn-custom-theme mx-1 btn-main w-25" (click)="activeModal.close()">
          ตกลง
        </button>
      </div>
    </div>
  </div>
</div>
